import { httpClient } from '@/network/clientController'

/** Request popups list
@docs https://issue.inm.pt/projects/c04401-banco-mais-middleware-integracao/wiki/GET_internetpopup
*/
export const requestPopupsList = payload => {
	return httpClient({
		method: 'GET',
		url: '/popup'
	})
}

/** Dismiss one popup
@docs https://issue.inm.pt/projects/c04401-banco-mais-middleware-integracao/wiki/POST_internetpopupdismiss
*/
export const dismissPopups = payload => {
	return httpClient({
		method: 'POST',
		url: '/popup/dismiss',
        data: payload
	})
}
